import { TAGS_ROUTES } from '../../constants/_routes'
import tagsTypes from '../../constants/tagsTypes'
import { axios } from '../../services'

// INDEX
const tags_index_request = () => {
  return {
    type: tagsTypes.index.request
  }
}

const tags_index_success = (response) => {
  return {
    type: tagsTypes.index.success,
    payload: response.data
  }
}

const tags_index_failure = (messages) => {
  return {
    type: tagsTypes.index.failure,
    payload: messages
  }
}

const tags_index = () => {
  return function (dispatch) {
    // Before Request
    dispatch(tags_index_request())

    // Request
    axios.get(
      TAGS_ROUTES.index
    ).then( response => {
      // success
      dispatch( tags_index_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching tags."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( tags_index_failure(errors))
    })
  }

}

export {
  tags_index
}



// WEBPACK FOOTER //
// ./src/js/actions/tags/getindex.js